import React, { useState, useEffect } from "react";
import "./Configuration.css";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { FiUsers } from "react-icons/fi";
import { RiUserCommunityLine } from "react-icons/ri";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { IoSettingsOutline } from "react-icons/io5";
import OrganizationConfig from "./OrganizationConfig/OrganizationConfig";
import ClientConfigSection from "./clientConfig/ClientConfigSection";
import SubVendorConfigSection from "./subVendorConfig/SubVendorConfigSection";
import EmployeeConfigSection from "./employeeConfig/EmployeeConfigSection";
import InvoiceConfigSection from "./invoiceConfig/InvoiceConfigSection";
import RecruitmentConfigSection from "./recruitmentConfig/RecruitmentConfigSection";
import JobRoleConfigSection from "./jobRoleConfig/JobRoleConfigSection";
import SalaryConfigSection from "./salaryConfig/SalaryConfigSection";
import AttendanceConfigSection from "./attendanceConfig/AttendanceConfigSection";
import SeparationConfigSection from "./separationConfig/SeparationConfigSection";
import { GrNotification } from "react-icons/gr";
import Header from "../../components/common/Header";


const Configuration = ({ setActivePage }) => {
  const [selectedTab, setSelectedTab] = useState("Client");
  const [selectedClient, setSelectedClient] = useState(null);
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    token: "",
    orgId: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "GUEST";
    const orgId = localStorage.getItem("orgId") || "";
    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
      orgId,
    });
  }, []);

  // Dummy: Set selected client from local storage
  useEffect(() => {
    const clientId = localStorage.getItem("clientId") || "ClientA";
    setSelectedClient(clientId);
  }, []);

  const tabIcons = {
    Client: <HiOutlineUserGroup />,
    Attendance: <HiOutlineClipboardDocumentCheck />,
    Salary: <HiOutlineClipboardDocumentCheck />,
    "Sub Vendors": <HiOutlineUserGroup />,
    "Job Role": <FiUsers />,
    Recruitment: <FiUsers />,
    Employee: <RiUserCommunityLine />,
    Separation: <RiUserCommunityLine />,
    Invoice: <HiOutlineClipboardDocumentCheck />,
    Organisation: <IoSettingsOutline />,
  };

  return (
    <div>
      <Header
        title="Configuration"
        subtitle="Configuration Information"
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      />

      <div className='config-table-container'>
        <div className='tabs'>
          {[
            "Client",
            "Attendance",
            "Salary",
            "Sub Vendors",
            "Job Role",
            "Employee",
            "Separation",
            "Invoice",
            "Recruitment",
          ].filter(tab => {
            const userEmail = localStorage.getItem("userEmail");
            if (userEmail === "nvguhan@wtilth.com") {
              return !["Invoice", "Separation", "Employee", "Sub Vendors", "Attendance", "Salary"].includes(tab);
            }
            return true;
          }).map((tab) => (
            <button
              key={tab}
              className={`tab-button ${selectedTab === tab ? "active" : ""}`}
              onClick={() => setSelectedTab(tab)}
            >
              <span className='menu-icon'>{tabIcons[tab]}</span>
              <span className='menu-name'>{tab}</span>
            </button>
          ))}
        </div>

        {selectedTab === "Client" && (
          <ClientConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Sub Vendors" && (
          <SubVendorConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Employee" && (
          <EmployeeConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Recruitment" && (
          <RecruitmentConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Separation" && (
          <SeparationConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Invoice" && (
          <InvoiceConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Job Role" && (
          <JobRoleConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Salary" && (
          <SalaryConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Attendance" && (
          <AttendanceConfigSection
            userDetails={userDetails}
            selectedClient={selectedClient}
          />
        )}

        {selectedTab === "Organisation" && <OrganizationConfig />}

        {selectedTab !== "Client" &&
          selectedTab !== "Organisation" &&
          selectedTab !== "Sub Vendors" &&
          selectedTab !== "Invoice" &&
          selectedTab !== "Recruitment" &&
          selectedTab !== "Job Role" &&
          selectedTab !== "Employee" &&
          selectedTab !== "Separation" &&
          selectedTab !== "Salary" &&
          selectedTab !== "Attendance" && (
            <div className='coming-soon'>
              <h2>{selectedTab} - Coming Soon</h2>
            </div>
          )}
      </div>
    </div>
  );
};

export default Configuration;
